<h3 id='cal-title' class="klarheit mb4 tc core-blue b" tabindex="0"
  attr.aria-live="{{ (month | jbMonthName) + ' '  + year + ' calendar ' + (isLoading ? 'loading' : 'loaded') }}">
  {{ month | jbMonthName }} {{ year }}
</h3>
